import { createStore } from "vuex";
import cartModule from "./cart.module";
import nonCartModule from "./non-cart.module";
import shoppingModule from "./shopping.module";
import userModule from "./user.module";
import displayModule from "./display.module";
import shoppingCartModule from "./shopping-cart.module";
import poModule from "./po.module";
import prModule from "./pr.module";
import receiptModule from "./receipt.module";
import changeDeliveryModule from "./change-delivery.module";
import goodReceiptModule from "./good-receipt.module";
import paymentRequestModule from "./payment-request.module";
import billPlacement from "./bill-placement.module";

export default createStore({
  modules: {
    cartModule,
    nonCartModule,
    shoppingModule,
    userModule,
    displayModule,
    shoppingCartModule,
    poModule,
    prModule,
    receiptModule,
    changeDeliveryModule,
    goodReceiptModule,
    paymentRequestModule,
    billPlacement,
  },
});
